import React from 'react';

import { makeStyles } from '@material-ui/core';

import Box from '@mui/material/Box';

import SwitcherComponent from '../../components/Headers/SwitcherComponent';

import { TabType } from '../../BaseTabsRouting';
import useTableContext, { PageType } from './useTableContext';

type Props = {
  tabulatedItems: TabType[];
  tabbedElement: TabType;
  setTabbedElement: React.Dispatch<TabType>;
  page;
};

const useStyles = makeStyles(() => ({
  root: { justifyContent: 'space-between', display: 'flex' },
  portalContainer: {
    display: 'flex',
    '&:only-child': {
      width: '100%'
    }
  }
}));

const DataGridToolBar = ({
  tabulatedItems,
  tabbedElement,
  setTabbedElement,
  page
}: Props) => {
  const { contentNodeForButtons, context } = useTableContext();

  const classes = useStyles();

  return (
    <div className={classes.root}>
      {context?.type === PageType.LIST && tabulatedItems.length > 1 ? (
        <Box mr={2} sx={{ whiteSpace: 'nowrap' }}>
          <SwitcherComponent
            tabbedElement={tabbedElement}
            tabulatedItems={tabulatedItems}
            setTabbedElement={setTabbedElement}
            page={page}
          />
        </Box>
      ) : (
        <></>
      )}
      <div
        className={classes.portalContainer}
        data-testid="portal"
        ref={contentNodeForButtons}
      />
    </div>
  );
};

export default DataGridToolBar;
